<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Qualifications</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreateQualification()">
        <mat-icon>add</mat-icon>
        Add Qualification
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="qualifications()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditQualification($event)"
      (deleteClick)="onDeleteQualification($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
